import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadOrderIdsQueryVariables = {
  search?: Types.Maybe<Types.Scalars['String']>
};


export type ReadOrderIdsQuery = (
  { __typename?: 'Query' }
  & { orderIds: Array<(
    { __typename?: 'OrderId' }
    & Pick<Types.OrderId, '_id' | '_deleted' | 'value' | 'validFrom' | 'validTo' | 'modified' | 'inactive'>
    & { modifiedBy: Types.Maybe<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'name' | 'email' | 'department' | 'roles'>
    )> }
  )> }
);

export type CreateOrderIdMutationVariables = {
  input?: Types.Maybe<Types.OrderIdInsertType>
};


export type CreateOrderIdMutation = (
  { __typename?: 'Mutation' }
  & { createOrderId: (
    { __typename?: 'OrderId' }
    & Pick<Types.OrderId, '_id'>
  ) }
);

export type CreateOrUpdateFromCsvMutationVariables = {
  uri: Types.Scalars['String']
};


export type CreateOrUpdateFromCsvMutation = (
  { __typename?: 'Mutation' }
  & { createOrUpdateFromCsv: (
    { __typename?: 'ExcelImportResult' }
    & Pick<Types.ExcelImportResult, 'total' | 'created' | 'modified'>
  ) }
);

export type UpdateOrderIdMutationVariables = {
  id?: Types.Maybe<Types.Scalars['ID']>,
  update?: Types.Maybe<Types.OrderIdSetType>
};


export type UpdateOrderIdMutation = (
  { __typename?: 'Mutation' }
  & { updateOrderId: Array<(
    { __typename?: 'OrderId' }
    & Pick<Types.OrderId, '_id'>
  )> }
);

export type DeleteOrderIdMutationVariables = {
  ids: Array<Types.Scalars['ID']>
};


export type DeleteOrderIdMutation = (
  { __typename?: 'Mutation' }
  & { deleteOrderId: Array<(
    { __typename?: 'OrderId' }
    & Pick<Types.OrderId, '_deleted'>
  )> }
);

export const ReadOrderIdsDocument = gql`
    query ReadOrderIds($search: String) {
  orderIds(filter: {value: {REGEX: $search, OPTIONS: "i"}}, validOnly: false) {
    _id
    _deleted
    value
    validFrom
    validTo
    modifiedBy {
      _id
      name
      email
      department
      roles
    }
    modified
    inactive
  }
}
    `;

    export function useReadOrderIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadOrderIdsQuery, ReadOrderIdsQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadOrderIdsQuery, ReadOrderIdsQueryVariables>(ReadOrderIdsDocument, baseOptions);
    };
      export function useReadOrderIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadOrderIdsQuery, ReadOrderIdsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadOrderIdsQuery, ReadOrderIdsQueryVariables>(ReadOrderIdsDocument, baseOptions);
      };
      
export type ReadOrderIdsQueryHookResult = ReturnType<typeof useReadOrderIdsQuery>;
export type ReadOrderIdsQueryResult = ApolloReactCommon.QueryResult<ReadOrderIdsQuery, ReadOrderIdsQueryVariables>;
export const CreateOrderIdDocument = gql`
    mutation CreateOrderId($input: OrderIdInsertType) {
  createOrderId(input: $input) {
    _id
  }
}
    `;
export type CreateOrderIdMutationFn = ApolloReactCommon.MutationFunction<CreateOrderIdMutation, CreateOrderIdMutationVariables>;

    export function useCreateOrderIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrderIdMutation, CreateOrderIdMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateOrderIdMutation, CreateOrderIdMutationVariables>(CreateOrderIdDocument, baseOptions);
    };
export type CreateOrderIdMutationHookResult = ReturnType<typeof useCreateOrderIdMutation>;
export type CreateOrderIdMutationResult = ApolloReactCommon.MutationResult<CreateOrderIdMutation>;
export type CreateOrderIdMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrderIdMutation, CreateOrderIdMutationVariables>;
export const CreateOrUpdateFromCsvDocument = gql`
    mutation CreateOrUpdateFromCsv($uri: String!) {
  createOrUpdateFromCsv(uri: $uri) {
    total
    created
    modified
  }
}
    `;
export type CreateOrUpdateFromCsvMutationFn = ApolloReactCommon.MutationFunction<CreateOrUpdateFromCsvMutation, CreateOrUpdateFromCsvMutationVariables>;

    export function useCreateOrUpdateFromCsvMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrUpdateFromCsvMutation, CreateOrUpdateFromCsvMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateOrUpdateFromCsvMutation, CreateOrUpdateFromCsvMutationVariables>(CreateOrUpdateFromCsvDocument, baseOptions);
    };
export type CreateOrUpdateFromCsvMutationHookResult = ReturnType<typeof useCreateOrUpdateFromCsvMutation>;
export type CreateOrUpdateFromCsvMutationResult = ApolloReactCommon.MutationResult<CreateOrUpdateFromCsvMutation>;
export type CreateOrUpdateFromCsvMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrUpdateFromCsvMutation, CreateOrUpdateFromCsvMutationVariables>;
export const UpdateOrderIdDocument = gql`
    mutation UpdateOrderId($id: ID, $update: OrderIdSetType) {
  updateOrderId(filter: {_id: {EQ: $id}}, update: {set: $update}) {
    _id
  }
}
    `;
export type UpdateOrderIdMutationFn = ApolloReactCommon.MutationFunction<UpdateOrderIdMutation, UpdateOrderIdMutationVariables>;

    export function useUpdateOrderIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderIdMutation, UpdateOrderIdMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateOrderIdMutation, UpdateOrderIdMutationVariables>(UpdateOrderIdDocument, baseOptions);
    };
export type UpdateOrderIdMutationHookResult = ReturnType<typeof useUpdateOrderIdMutation>;
export type UpdateOrderIdMutationResult = ApolloReactCommon.MutationResult<UpdateOrderIdMutation>;
export type UpdateOrderIdMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrderIdMutation, UpdateOrderIdMutationVariables>;
export const DeleteOrderIdDocument = gql`
    mutation DeleteOrderId($ids: [ID!]!) {
  deleteOrderId(filter: {_id: {IN: $ids}}) {
    _deleted
  }
}
    `;
export type DeleteOrderIdMutationFn = ApolloReactCommon.MutationFunction<DeleteOrderIdMutation, DeleteOrderIdMutationVariables>;

    export function useDeleteOrderIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOrderIdMutation, DeleteOrderIdMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteOrderIdMutation, DeleteOrderIdMutationVariables>(DeleteOrderIdDocument, baseOptions);
    };
export type DeleteOrderIdMutationHookResult = ReturnType<typeof useDeleteOrderIdMutation>;
export type DeleteOrderIdMutationResult = ApolloReactCommon.MutationResult<DeleteOrderIdMutation>;
export type DeleteOrderIdMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOrderIdMutation, DeleteOrderIdMutationVariables>;